import React, { forwardRef, useEffect, useState } from 'react';
import { Spin, Tooltip, Button, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './cutomizedModuleStyle.scss';
import SectionComment from 'src/ddvComment/SectionComment';
import AnchorComponent from '@modules/customizedModule/anchorComponent';

import { urlTabMap } from '@components/directUser/data';
import IntegrationHubViewMode from '@components/hubModule/hubModule-view-mode';
import useRefreshPowerBI from '@hooks/useRefreshPowerBI';
import useCustomizedModuleData from '@hooks/useCustomizedModuleData';
import { useSelector } from 'react-redux';
import { buttonRefreshPatternMatch } from '@utils/buttonRefreshPatternMatch';
import { extractReportId } from '@utils/reportIDExtracter';
import store from '@flux/store';
import actions from '@flux/action';

function CustomizedPowerBIModule(props, ref) {
  const { history } = props;
  const url = decodeURIComponent(history.location?.search);
  const params = new URLSearchParams(url);
  const projectId = params.get('projectId');
  const moduleValue = params.get('moduleValue');
  const integrationModuleId = params.get('integrationModuleId');
  const {
    targetModuleData: { link, moduleName, identifier },
  } = useCustomizedModuleData(moduleValue, integrationModuleId);
  const { refreshPowerBIKey, refreshBtnLoading, toggleRefreshPowerBI } =
    useRefreshPowerBI(projectId, link, moduleName, identifier, 'powerbi');

  const [pbiRefreshDisable, setPbiRefreshDisable] = useState(false);
  const [pbiRefreshCompDisable, setPbiRefreshCompDisable] = useState(false);
  const [uniqueButtonId, setUniqueButtonId] = useState('');
  const [powerBIRefershData, setPowerBIRefershData] = useState({});
  const [refreshCompleteModal, setRefreshCompleteModal] = useState(false);
  const [timer, setTimer] = useState(5);

  const moduleNameID = moduleName.replace(/ /g, '');
  console.log('identifier :', identifier, '}}', moduleNameID);

  const powerBIRefershReducerData = useSelector(
    (state) => state.powerBIRefreshReducer,
  );

  useEffect(() => {
    const reportId = extractReportId(link);
    setUniqueButtonId(`${reportId}_${moduleNameID}`);
  }, [link]);

  useEffect(() => {
    // console.log('PBI store data', powerBIRefershReducerData);
    setPowerBIRefershData(powerBIRefershReducerData);
  }, [powerBIRefershReducerData]);

  useEffect(() => {
    if (powerBIRefershData.type === 'notification') {
      const refreshData = powerBIRefershData;
      let refreshFlagData = buttonRefreshPatternMatch(refreshData.messages);
      // console.log('refreshFlagData : ', refreshFlagData);
      if (
        refreshFlagData[0] &&
        !refreshCompleteModal &&
        refreshFlagData[1] === uniqueButtonId
      ) {
        setRefreshCompleteModal(true);
      }
    }
  }, [powerBIRefershData]);

  useEffect(() => {
    setPbiRefreshDisable(
      powerBIRefershData?.buttonList?.includes(uniqueButtonId),
    );
    // if (powerBIRefershData?.buttonList?.includes(!uniqueButtonId)) {
    //   setPbiRefreshCompDisable(false);
    //   setRefreshCompleteModal(true);
    // }
  }, [powerBIRefershData]);

  useEffect(() => {
    if (pbiRefreshCompDisable && !pbiRefreshDisable) {
      setPbiRefreshCompDisable(false);
      // setRefreshCompleteModal(true);
    }
  }, [pbiRefreshDisable]);

  useEffect(() => {
    let interval;
    if (refreshCompleteModal) {
      // Start countdown when modal becomes visible
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            refreshBrowser();
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [refreshCompleteModal]);

  const refreshBrowser = () => {
    if (refreshCompleteModal) {
      window.location.reload();
    }
  };

  const closeRefreshModal = () => {
    store.dispatch(actions.clearPBIrefreshData());
    setRefreshCompleteModal(false);
  };

  useEffect(() => {
    urlTabMap['/powerBI'] = { moduleName, identifier: moduleValue };
    return () => {
      Reflect.deleteProperty(urlTabMap, '/powerBI');
    };
  }, [moduleName, moduleValue]);

  useEffect(() => {
    if (pbiRefreshCompDisable && !pbiRefreshDisable) {
      setPbiRefreshCompDisable(false);
      // setRefreshCompleteModal(true);
    }
  }, [pbiRefreshDisable]);

  const extraButton = (
    <>
      {refreshCompleteModal ? (
        <Modal
          className="pbirefreshmodal"
          visible={refreshCompleteModal}
          title="PBI Refresh Notification"
          closable={{ 'aria-label': 'Custom Close Button' }}
          ariaLabel="PBI Refresh Notification"
          onCancel={closeRefreshModal}
          modalStyle={{ width: '33.75rem' }}
          footerStyle={{
            paddingTop: '8px',
            marginTop: '-8px',
            minHeight: '64px',
          }}
          header={''}
          footer={
            <div>
              <button
                type="button"
                className="pbiRefreshClose"
                onClick={closeRefreshModal}
              >
                Close
              </button>
            </div>
          }
          bodyStyle={{ minHeight: '92px' }}
        >
          <p>
            Dashboard refresh complete. Refreshing browser in {timer} seconds.
          </p>
        </Modal>
      ) : (
        ''
      )}
      {/* <Spin
        spinning={refreshBtnLoading}
        indicator={<LoadingOutlined spin />}
        size="small"
      >
        <Tooltip
          placement="topLeft"
          title={
            pbiRefreshCompDisable || pbiRefreshDisable ? 'Refresh Ongoing' : ''
          }
          overlayClassName="add-manage-form-tooltip"
        >
          <Button
            id={uniqueButtonId}
            className="edit-sections role-control"
            style={{
              cursor: pbiRefreshDisable ? 'not-allowed' : 'pointer',
            }}
            onClick={() => {
              if (!link) {
                return;
              }
              console.log('identifier BID : ', uniqueButtonId);
              setPbiRefreshCompDisable(true);
              toggleRefreshPowerBI();
            }}
            disabled={pbiRefreshDisable || pbiRefreshCompDisable} // Disable button based on conditions
          >
            <span className="appkiticon icon-refresh-outline" />
          </Button>
        </Tooltip>
      </Spin> */}
      <div className="customized-module-power-bi-comment-icon">
        <SectionComment
          module={moduleName}
          component=""
          placement="bottomRight"
          sendIdentifier={moduleValue}
          // getPopupContainer={() =>
          //   document.getElementsByClassName('integration-tile')[0]
          // }
        />
        <AnchorComponent anchorId={moduleValue} />
      </div>
    </>
  );

  return (
    <IntegrationHubViewMode
      key={refreshPowerBIKey}
      {...props}
      ref={ref}
      extraButton={extraButton}
    />
  );
}

export default forwardRef(CustomizedPowerBIModule);
